import script from "./MsSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./MsSwitch.vue?vue&type=style&index=0&id=efb486b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb486b6"]])

export default __exports__